import React from 'react';

interface SecurityWarningProps {
  onClose?: () => void;
}

const SecurityWarning: React.FC<SecurityWarningProps> = () => {
  // Disabled security warning to improve user experience
  // No longer showing alerts for developer tools or screen zoom
  return null;
};

export default SecurityWarning;
